import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { observer } from "mobx-react";
import React from "react";
import { store } from "../../store";
import { LanguageMode } from "../../domain/providers/i18n-provider";
import { cn } from "@/lib/utils";

export type LanguageSelectorProps = {
    className?: string;
};

export const LanguageSelector = observer(({ className }: LanguageSelectorProps): JSX.Element => {
    const options = store.i18n.availableLanguages.map((data) => ({
        key: data.code,
        text: data.name,
        data,
    }));

    const current = store.i18n.language ?? store.i18n.availableLanguages[0].code;

    return (
        <Select
            value={current}
            onValueChange={(code) => {
                store.i18n.changeLanguage({ mode: LanguageMode.MANUAL, code });
            }}
        >
            <SelectTrigger className={cn("w-[120px]", className)}>
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {options.map((o) => (
                    <SelectItem value={o.key} key={o.key}>
                        <div className={`fi fi-${o.data.flag} mr-2 h-4 w-4`}></div>
                        {o.text}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
});
